import { Injectable, ComponentFactoryResolver } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class PinGuard implements CanActivate {

  constructor(private router: Router) {

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      // time without pin in minutes
      const timeWithoutPinAllowed = 60 * 12;

      const now = +new Date();
      const timestamp = +new Date(JSON.parse(window.localStorage.getItem('pincode_entered')));
      const timeDiff = (now - timestamp) / 60000;

      if (!!timestamp && (timeDiff <= timeWithoutPinAllowed)) {
        return true;
      } else {
        // need a pin to access this page, so go to the pinpage
        this.router.navigate(['/pin'], { queryParams: { returnUrl: state.url }});
        return false;
      }    
  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/guards/pin.guard.ts